import { defineComponent, onMounted } from 'vue';
import { MultiSelect } from '@studyportals/multiselect';
import ActSelectDashboardsCode from '@/presentation/components/act-access-modal/act-select-dashboards/act-select-dashboards.code';

export default defineComponent({
	components: {
		MultiSelect
	},
	setup: () => {
		const code = new ActSelectDashboardsCode();

		onMounted(code.mounted.bind(code));

		return {
			dashboardDropdown: code.dashboardDropdown,
			options: code.options,
			invalidSelectionMessage: code.invalidSelectionMessage,
			amountOfDashboardsBasedSentence: code.amountOfDashboardsBasedSentence,
			handleDropdownInput: code.handleDropdownInput.bind(code)
		};
	}
});
